import { Injectable } from '@angular/core';

export const LOCAL_STORAGE_KEYS = {
  REDIRECT_AFTER_LOGIN: 'redirectAfterLogin',
  USER_LOCAL_STORAGE_KEY: 'userData',
  BEARER_STORAGE_KEY: 'bearer',
  TOKEN_LOCAL_STORAGE_KEY: 'refreshToken',
  TOKEN_EXPIRES_LOCAL_STORAGE_KEY: 'refreshTokenExpires',
  LOCAL_STORAGE_TIMER_KEY: 'lastActive',
  COOKIES_ANALYTICS_CATEGORY: 'analytics',
  COOKIE_STORAGE_KEY: 'cc_cookie',
  NATIVE_COOKIE_STORAGE_KEY: 'native_ccookie',
}

interface SetOptions {
  key: string,
  value: string,
}

interface GetOptions {
  key: string,
}

interface RemoveOptions {
  key: string,
}

/**
 * Created to prevent iOS localStorage unexpected clears.
 * 08/2025 - For workplace split it was just left without Capacitor features, in case of localstorage features or so.
 * https://forum.ionicframework.com/t/strange-bug-ios-local-storage-is-being-erased/147344/7
 */
@Injectable({
  providedIn: 'root'
})
export class LocalStorageService {
  public setItem(data: SetOptions): void {
      localStorage.setItem(data.key, data.value);
  }

  public getItemSync(data: GetOptions): string | null {
    return localStorage.getItem(data.key);
  }

  public deleteItemSync(data: RemoveOptions): void {
    localStorage.removeItem(data.key);
  }

  public deleteItem(data: RemoveOptions): void {
    localStorage.removeItem(data.key);
  }

  public clear(): void {
    localStorage.clear();
  }
}
